import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import { disableBodyScroll } from 'body-scroll-lock';

@Directive({
  selector: '[app-dropdown-trigger]'
})
export class DropdownTriggerDirective {
  @HostBinding('class.dropdown-trigger') dropdownTrigger = true;
  @HostBinding('class.opened') @Input() active: boolean = false;
  @HostListener('click', ['$event']) onClick(event: PointerEvent) {
    event.preventDefault();

    disableBodyScroll(this.element.nativeElement);
    this.active = !this.active;
    this.toggle.emit(this.active);
  }
  @Output() toggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private element: ElementRef) {}

  getTriggerParams(): DOMRect {
    return this.element.nativeElement.getBoundingClientRect();
  }
}
